<template>
  <div class="contentBox">
    <navBox :id="navId" ref="navBox"></navBox>
    <!-- 列表 -->
    <div class="content">
      <myHeader ref="myHeader"></myHeader>
      <!-- 添加 -->
      <div class="MobelBox" v-if="addType" v-loading="loading" :element-loading-text="loadTxt">
        <p class="title">{{addType=='add'?'添加':'编辑'}}</p>
        <form>
          <div class="write-txt">
            <p class="write-title">
              类型<span>*</span>
            </p>
            <div class="write-text">
              <el-radio-group v-model="addObj.type">
                <el-radio label="1">正式包</el-radio>
                <el-radio label="2">测试包</el-radio>
              </el-radio-group>
            </div>
          </div>
          <div class="write-txt">
            <p class="write-title">
              客户端<span>*</span>
            </p>
            <div class="write-text">
              <el-radio-group v-model="addObj.client">
                <el-radio label="1">安卓</el-radio>
                <el-radio label="2">苹果</el-radio>
              </el-radio-group>
            </div>
          </div>
          <div class="write-txt">
            <p class="write-title">
              系统升级<span>*</span>
            </p>
            <div class="write-text">
              <el-radio-group v-model="addObj.upgrade">
                <el-radio label="1">强制升级</el-radio>
                <el-radio label="2">提醒升级</el-radio>
                <el-radio label="0">不提醒升级</el-radio>
              </el-radio-group>
            </div>
          </div>
          <div class="write-txt">
            <p class="write-title">
              版本号<span>*</span>
            </p>
            <div class="write-text">
              <input type="number" v-model="addObj.version">
            </div>
          </div>
          <div class="write-txt">
            <p class="write-title">
              更新内容<span>*</span>
            </p>
            <div class="write-text">
              <input type="text" v-model="addObj.content">
            </div>
          </div>
          <div class="write-txt">
            <p class="write-title">上传文件<span class="hide">*</span></p>
            <div class="write-text" style="display: inline-block;width:10%;">
              <el-upload
                :action="'https://upload.qiniup.com'"
                :data="uploadObj"
                list-type="picture-card"
                :before-upload="beforeUpload"
                :on-success="(response, file, fileList)=>{return handleSuccess(response, file, fileList)}"
                :on-progress="handleProgressImg"
                :on-remove="(response, file, fileList)=>{return handleRemove(response, file, fileList)}">
              >
                <i class="el-icon-plus"></i>
              </el-upload>
            </div>
            <div class="write-text" style="display: inline-block;width:10%;">
              <input type="text" v-model="addObj.url" v-if="addObj.url">
            </div>
          </div>
        </form>
        <div class="btnBox">
          <button class="btn btn-sub" @click="saveSub">确认</button>
          <button class="btn btn-close" @click="closeSub">取消</button>
        </div>
      </div>
      <div class="organiza-txt" v-else>
        <div class="organiza-title clear">
          <div class="organiza-left" @click="addSub">
            <img src="~@/assets/images/icon-add.png" alt="">
            <p>添加</p>
          </div>
        </div>
        <div class="organiza-list">
          <div class="titleList">
            <p v-for="item in titleList" v-bind:key="item.id">{{item.title}}</p>
          </div>
          <div class="dataList">
            <div class="listItem" v-for="(item,index) in dataList" v-bind:key="(index+1)">
              <p :title="item.id">{{item.id}}</p>
              <p :title="item.type==2?'测试包':'正式包'">{{item.type==2?'测试包':'正式包'}}</p>
              <p :title="item.client==2?'苹果':'安卓'">{{item.client==2?'苹果':'安卓'}}</p>
              <p :title="item.version">{{item.version}}</p>
              <p :title="item.url">{{item.url}}</p>
              <p :title="item.upgrade==1?'强制升级':item.upgrade==2?'提醒升级':'不提示升级'">{{item.upgrade==1?'强制升级':item.upgrade==2?'提醒升级':'不提示升级'}}</p>
              <p :title="item.content">{{item.content}}</p>
              <p :title="item.add_time">{{item.add_time}}</p>
              <p>
                <button title="删除" @click="removeShow(item)" class="btn btn-remove"></button>
              </p>
            </div>
          </div>
          
          <div class="block pageBox clear">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="obj.page"
              :page-size="1"
              layout="prev, pager, next, jumper"
              :total="totalPage">
            </el-pagination> 
          </div>
        </div>
      </div>

      
    </div>

    <div class="msgBox" v-if="removeType">
      <div class="contv" style="height: auto;">
        <p class="title">是否确定删除？</p>
        <div class="btnBox">
          <button class="btn btn-close" @click="closeSub">取消</button>
          <button class="btn btn-sub" @click="removeSub">确定</button>
        </div>
      </div>
    </div>

    
  </div>
</template>

<script>

import { getAppUpdateList, saveAppUpdate ,getVipDetail,delAppUpdate,getUploadToken} from "@/assets/js/api";
import navBox from './../components/comment/nav.vue';
import myHeader from './../components/comment/myHeader.vue';
export default {
  name: "updateIndex",
  data() {
    return {
      navId:'22',
      titleList:[
        {id:2,title:'ID'},
        {id:3,title:'类型'},
        {id:4,title:'客户端'},
        {id:5,title:'版本号'},
        {id:6,title:'下载链接'},
        {id:7,title:'系统升级'},
        {id:8,title:'更新内容'},
        {id:9,title:'更新时间'},
        {id:1,title:'操作'},
      ],
      dataList:[
      ],
      addType:'',
      removeType:false,
      obj:{
        page:1,
        rows:10,
      },
      addObj:{
        type:'1',
        client:'1',
        upgrade:'1',
        version:'',
        content:'',
        url:''
      },
      totalPage:0,
      token:'',
      removeID:'',
      imgType:false,
      uploadObj: {
        token: "",
        key: "",
      },
      loading:false,
      loadTxt:''
    };
  },
  components: {
    navBox,
    myHeader
  },
  mounted(){
    this.token = localStorage.getItem('token');
    this.getList();
    this.getToken();
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.getList();
    },

    async getToken(){
      var that = this;
      try {
        const response = await getUploadToken(this.token);
        if(response.code == 200){
          that.uploadObj.token = response.data.token
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      };
    },

    searchSub(){
      this.obj.page = 1;
      this.dataList = [];
      this.getList();
    },

    resetSub(){
      this.obj = {
        page:1,
        rows:10,
        
      };
      this.addObj = {
        type:'1',
        client:'1',
        upgrade:'1',
        version:'',
        content:'',
        url:''
      }
      this.dataList = [];
      this.getList();
    },

    

    async getList(){
      var that = this;
      try {
        const response = await getAppUpdateList(this.obj,this.token);
        if(response.code == 200){
          response.data.list.forEach(function(item,index){
            if(item.publish_status==0){
              item.publish_status=false
            } else {
              item.publish_status=true
            }
          })
          that.dataList = response.data.list;
          that.totalPage = response.data.total_page;    
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    addSub(){
      this.addType = 'add';
    },

    async saveSub(){
      var that = this;
      
      if(this.addObj.version == ''){
        that.$message('请输入版本号！');
        return false;
      }
      if(this.addObj.url == ''){
        that.$message('请选择下载链接！');
        return false;
      }
      if(this.addObj.content == ''){
        that.$message('请输入更新内容！');
        return false;
      }
      try {
        const response = await saveAppUpdate(this.addObj,this.token);
        if(response.code == 200){
          that.$message('成功');
          that.addType = '';
          that.resetSub(); 
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    async reviseShow(e){
      var that = this;
      try {
        const response = await getVipDetail({id:e.id},this.token);
        if(response.code == 200){
          response.data.type = JSON.stringify(response.data.type);
          response.data.is_selected = JSON.stringify(response.data.is_selected);
          response.data.model = JSON.stringify(response.data.model);
          response.data.sort = JSON.stringify(response.data.sort);
          response.data.vip_type = JSON.stringify(response.data.vip_type);
          response.data.credits_issue_way = JSON.stringify(response.data.credits_issue_way);
          that.vip_date = JSON.parse(JSON.stringify(response.data.vip_time.split('')[response.data.vip_time.split('').length-1]));
          that.addObj = JSON.parse(JSON.stringify(response.data));
          var time = '';
          response.data.vip_time.split('').forEach(function(item,index){
            if(index == (response.data.vip_time.split('').length-1)){

            } else {
              time = time + item
            }
          })
          that.addObj.vip_time = time;
          that.addType = 'revise';
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    removeShow(e){
      var that = this;
      this.removeType = true;
      this.removeID = e.id;
    },

    async removeSub(e){
      var that = this;
      try {
        const response = await delAppUpdate({id:this.removeID},this.token);
        if(response.code == 200){
          that.$message('成功');
          that.removeType = '';
          that.resetSub();
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    closeSub(){
      this.removeType = false;
      this.addType = '';
      this.addObj = {
          type:'1',
        client:'1',
        upgrade:'1',
        version:'',
        content:'',
        url:''
      };
      this.removeID = '';
    },

    imgShow(){
      this.imgType = true;
    },

    imgHide(){
      this.imgType = false;
    },

    imgRemove(){
      this.addObj.image = '';
    },

    beforeUpload(file) {
      this.loading = true;
      this.uploadObj.key = file.uid + file.name; // key为上传后文件名 必填
    },

    handleProgressImg(event, file, fileList) {
      this.loadTxt = "已上传" + file.percentage.toFixed(0) + "%";
    },

    handleSuccess(response, file, fileList) {
      this.addObj.url = response.key;
      this.loading = false;
      this.uploadObj.key = "";
    },

    handleRemove(response, file, fileList,index) {
      this.addObj.url = "";
    },
  }

  
};
</script>
<style scoped>
  .dataList .listItem p, 
  .organiza-list p{
    width: calc( 100% / 9 );
  }

  .btn-remove,
  .btn-revise{
    background-image: url(~@/assets/images/btn-revise.png);
    width: 22px;
    height: 22px;
    background-size: 22px 22px;
    display: inline-block;
    vertical-align: top;
  }

  .btn-remove{
    background-image: url(~@/assets/images/btn-remove.png);
    margin-left: 20px;
  }

  .MobelBox{
    margin: 20px;
    box-sizing: border-box;
    width: 100%;
    height: calc( 100% - 120px );
  }

  .MobelBox form{
    background-color: #fff;
    padding: 30px;
    box-sizing: border-box;
  }

  .MobelBox .write-txt{
    display: block;
    width: 100%;
    margin-bottom: 20px;
  }

  .MobelBox .write-title{
    font-size: 18px;
    color: #333333;
    display: inline-block;
    vertical-align: top;
    width: 200px;
  }

  .MobelBox .write-title span{
    color: #E2231A;
  }

  .MobelBox .write-text{
    display: inline-block;
    vertical-align: top;
    width: 80%;
    margin-left: 20px;
  }

  .MobelBox .write-text span{
    font-size: 14px;
    color: #E2231A;
    margin-top: 10px;
    display: block;
  }

  .MobelBox input,
  .MobelBox textarea{
    width: 80%;
    height: 65px;
    background-color: #F5F5F5;
    border-radius: 16px;
    display: block;
    padding: 10px;
    box-sizing: border-box;
  }

  .MobelBox input{
    width: 360px;
    height: 65px;
  }

  .MobelBox input.vip_time{
    display:inline-block;
    width: 120px;
    padding: 0 10px;
    margin-right: 20px;
  }

  .MobelBox .btnBox{
    display: block;
    margin-top: 30px;
    text-align: right;
    margin-right: 40px;
  }

  .MobelBox .btnBox .btn{
    font-size: 20px;
    color: #999999;
    box-sizing: border-box;
    padding: 14px 40px;
    border-radius: 16px;
    display: inline-block;
    vertical-align: top;
    background-color: #F9F9F9;
  }

  .MobelBox .btnBox .btn.btn-sub{
    background-color: #6E2FFF;
    color: #fff;
    margin-right: 40px;
  }

  .write-btnBox{
    float: right;
    width: 100%;
    text-align: right;
  }

  .write-btnBox .btn{
    width: 120px;
    height: 56px;
    line-height: 56px;
    border-radius: 16px;
    color: #fff;
    background-color: #6E2FFF;
    padding: 0;
    margin: 0;
    font-size: 20px;
  }

  .write-btnBox .btn.btn-close{
    color: #999999;
    background-color: #F5F5F5;
    margin-left: 40px;
  }

  .msgBox .contv{
    padding: 40px 73px;
    border-radius: 32px;
  }

  .msgBox .title {
    text-align: center;
    margin-bottom: 50px;
  }

  .searchBox>>>.search-item input{
    width: 160px;
  }

  .msgBox .contv{
    height: 80%;
  }

  .msgBox .btnBox{
    margin-top: 50px;
  }

  .msgBox>>>.el-radio__label{
    font-size: 15px;
  }
  .msgBox>>>.el-radio-group .el-radio{
    line-height: 30px;
  }

  .write-txt>>> .el-radio__inner{
    width: 20px;
    height: 20px;
  }

  .write-txt>>> .el-radio__inner::after{
    width: 10px;
    height: 10px;
  }

  .write-txt>>> .el-radio__label{
    font-size: 18px;
    vertical-align: top;
  }

  .write-txt>>> .el-radio-group{
    display: inline-block;
    vertical-align: top;
    line-height: 65px;
  }
</style>



// WEBPACK FOOTER //
// src/update/index.vue